/**
 * Global feature flags and toggles.
 * These are configuration values that affect application behavior globally.
 */

export function isMarketingConsentEnabled() {
  return window.SCHA.toggles.marketingConsentEnabled;
}

export function isLineLevelCustomerOrderNumberEnabled() {
  return window.SCHA.toggles.customerOrderNumberAtLineLevel;
}

export function isTruncateDesignationsEnabled() {
  return true;
}

export function isInvoiceNumberEnabled() {
  return window.SCHA.config.downloadInvoice;
}

export function isCADInquiryEnabled() {
  return false;
}

export function isMultiAccountOrderSearchEnabled() {
  return window.SCHA.toggles.multipleAccountSearchEnabled;
}

export function isPartialDeliveriesEnabled() {
  return true;
}

/**
 * When enabled, surcharge is already included in price coming from SAP (old way).
 * When disabled, surcharge will be added by the FE (new way).
 */
export function isSurchargeIncludedInPriceValue() {
  return window.SCHA.config.isSurchargeIncludedInPriceValue ?? false;
}

export function showDateAsCalendarWeek() {
  return window.SCHA.feature.showDateAsCalendarWeek ?? false;
}

export function isBEPriceCalculationEnabled() {
  return window.SCHA.feature.bePriceCalculation ?? false;
}

export function isPhaseOut2Enabled() {
  return window.SCHA.feature.enablePhaseOut2 ?? false;
}
